
/**
 * @typedef {Object} UserNoticesUreadCountCache キャッシュデータの構造
 * @property {number} timestamp 更新日時（ミリ秒）
 * @property {number} unreadCount 未読件数
 */

class UserNoticesUnreadManager {
    EXPIRE_DURATION = 3 * 60 * 1000 // 3min
    STORAGE_KEY = 'USER_NOTICES_UNREAD_COUNT_CACHE'
    /**
     * APIまたはCacheから取得
     *
     * @returns {Promise<number>} 未読件数
     */
    async fetch ()  {
        return this.getByCache() ?? await this.fetchByApi().then(unreadCount => {
            this.setCache(unreadCount);
            return unreadCount;
        });
    }
    /**
     * APIから取得
     *
     * @returns {JQuery.PromiseBase<number>} 未読件数
     */
    fetchByApi () {
        return $.ajax({
            type: 'GET',
            url: '/api/user-notice/unread-count',
            dataType: 'json',
            cache: false,
        }).then(v => {
            return v.unreadCount;
        });
    }
    /**
     * キャッシュから取得
     *
     * @returns {number} 未読件数
     */
    getByCache () {
        /** @type {UserNoticesUreadCountCache | null} */
        const cacheData = getSessionStorage(this.STORAGE_KEY);
        if (!cacheData) return;
        // cache期限切れ確認
        const diff = Date.now() - cacheData.timestamp;
        if (diff > this.EXPIRE_DURATION) return;
        return cacheData.unreadCount;
    }
    /**
     * キャッシュに保存
     *
     * @param {number} unreadCount 未読件数
     * @returns {void}
     */
    setCache (unreadCount) {
        /** @type {UserNoticesUreadCountCache} */
        const cacheData = {
            timestamp: Date.now(),
            unreadCount,
        }
        setSessionStorage(this.STORAGE_KEY, cacheData);
    }
    /**
     * キャッシュを削除
     *
     * @returns {void}
     */
    clearCache () {
        sessionStorage.removeItem(this.STORAGE_KEY);
    }
    /**
     * 未読バッジに描画
     *
     * @param {number} unreadCount 未読件数
     * @returns {void}
     */
    render (unreadCount) {
        const $badge = $('.js-user-notices-unread-count');
        $badge.text(unreadCount).toggleClass('disp-none', !unreadCount);
    }
}

export const userNoticesUnreadManager = new UserNoticesUnreadManager();

$(() => {
    if (!isLogin) return;
    if (isAccessRestricted) return;
    userNoticesUnreadManager.fetch().then(unreadCount => {
        userNoticesUnreadManager.render(unreadCount);
    });
});
